import { Button, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useTheme } from "../context/ThemeContext";
import CONSTANTS from "../utils/constants";
import arrowLeft from "../assets/img/arrow-left-short.svg";
import arrowLeftWhite from "../assets/img/arrow-left-short-white.svg";

const PaymentNotSupported = () => {
    const { theme } = useTheme();

    const handleBack = () => {
        window.history.back();
    }

    return (
        <div className="d-flex flex-column py-4 rounded-3 info-pannel">
            <div>
                <p className="volte-medium">
                    <FormattedMessage
                        id={CONSTANTS.VALIDATION_ERRORS.PAYMENT_METHOD}
                        defaultMessage="Payment method is not supported. Please choose another Payment method."
                    />
                </p>
            </div>
            <Row className="d-flex align-items-center mt-3">
                <Col>
                    <Button
                        className="volte-medium"
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleBack}
                        data-testid="pm-back-btn"
                    >
                        <img src={theme === "light" ? arrowLeft : arrowLeftWhite} alt="Back arrow" />{" "}
                        <FormattedMessage
                            id={CONSTANTS.PAYMENT_FORM.BUTTON.CHOOSE_OTHER_PAYMENT_METHOD}
                            defaultMessage="Choose other payment method"
                        />
                    </Button>
                </Col>
            </Row>
        </div>
    );
}

export default PaymentNotSupported;